module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/4/3-152bdc3aecd0de875b505577f9a083e8.jpg";